<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <button type="submit" class="btn btn-main p-4" :disabled="loading">
    <font-awesome-icon
      v-if="loading"
      :icon="['fas', 'spinner']"
      class="mr-1"
      spin
    />
    <slot v-else />
  </button>
</template>
